import React from 'react';
import AddressDirectory from '../../shared/Address/AddressDirectory/AddressDirectory';

import { Trans } from '@lingui/macro';
import { APPLICANT } from '../../../constants/modelNames';

function ApplicantAddress(): JSX.Element {
  return (
    <div className="Form__Row">
      <AddressDirectory model={APPLICANT} />
      <div className="Form__Aside Form__Aside_address">
        <div className="Content__sub">
          <p className="Content__subText">
            <Trans>
              Для ввода адреса в Зеленограде, в случае отсутствия улицы и дома,
              укажите адрес в формате: «Зеленоград, корпус N»
            </Trans>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ApplicantAddress;
